<template>
	<el-row class="container">
		<el-col :span="24">NOT FOUND</el-col>
	</el-row>
</template>

<script>
	export default {
	}
</script>



// WEBPACK FOOTER //
// NotFound.vue?499bc3d0